import type { Console } from './types.js';

import { stdConsole } from './std-console.js';

export const console: Console = stdConsole;
